import { getOrganization } from './organizationSelectors';

export const getState = state => state.organizationSettings;

export const getName = state => {
    const { newOrgName } = getState(state);
    if (newOrgName !== undefined) {
        return newOrgName;
    }
    const organization = getOrganization(state);
    return organization.name;
};

export const getGa = state => {
    const { ga } = getState(state);
    if (ga !== undefined) {
        return ga;
    }
    const organization = getOrganization(state);
    return organization.ga;
};

export const getIsFormValid = state => {
    const name = getName(state);
    if (!name.trim()) {
        return false;
    }

    const ga = getGa(state);
    if (!ga) {
        return false;
    }

    const { analyticsOn, trackingId } = ga;
    if (analyticsOn && (!trackingId || !trackingId.trim())) {
        return false;
    }

    return true;
};

export const getIsLoading = state =>
    getState(state).loading || getState(state).gaLoading;

export const getError = state => getState(state).error;

export const getGaError = state => getState(state).gaError;



// WEBPACK FOOTER //
// ./src/selectors/organizationSettingsSelectors.js